export default __webpack_public_path__ + "static/media/project_banner_holdme.b35aa5c3.png";